<lyceo-content *transloco="let t" [background]="true" [alternate]="true">
  <lyceo-single-card-layout>
    <homi-logo class="mb-5" header />
    <h1 data-testid="login-title" class="mb-3">
      {{ t('pages.login.title') }}
    </h1>
    <p data-testid="login-description" class="mb-3">
      {{ t('pages.login.description') }}
    </p>
    @if (clearWebsiteAvailable()) {
      <p data-testid="current-website" class="paragraph-small mb-3">
        {{ t('pages.login.current_website', { website: website() }) }}
        ·
        <button
          data-testid="change-website"
          lyceoButton
          type="button"
          [size]="ButtonSize.SMALL"
          [fill]="ButtonFill.CLEAR"
          (click)="clearWebsite()"
        >
          {{ t('pages.login.change_website') }}
        </button>
      </p>
    }
    <button
      data-testid="login-school"
      class="mb-3"
      lyceoButton
      [block]="true"
      [status]="ComponentStatus.PRIMARY"
    >
      {{ t('pages.login.login_school') }}
    </button>
    <button
      data-testid="login"
      lyceoButton
      (click)="login()"
      [block]="true"
      [status]="ComponentStatus.PRIMARY"
    >
      {{ t('pages.login.login_homi') }}
    </button>
  </lyceo-single-card-layout>
</lyceo-content>
